import Reset from '@components/icons/Reset.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAPI } from '@providers/useAPI';
import { useModalContext } from '@providers/ModalProvider';
import { useMutation } from '@tanstack/react-query';
import { PipelineAttemptsService } from 'app/API';
import toast from 'react-hot-toast';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { MenuItemButton } from '../MoreActionsMenu/components/MenuItemButton';

export const ResetJobButton = () => {
  const { call } = useAPI();
  const { openModal, closeModal } = useModalContext();
  const { jobId, pipelineLoading, manualReload, loadPipeline } = usePageContext();

  const resetMutation = useMutation({
    mutationFn: () => call(() => PipelineAttemptsService.resetJobToDraft({ jobId })),
    onSuccess: async () => {
      toast.success('Job reset to draft');
      await loadPipeline();
      manualReload();
    },
    onError: () => {
      toast.error('Unable to reset job to draft');
    },
  });
  const isResettingJob = resetMutation.isPending;

  if (!jobId) {
    return null;
  }

  const confirmResetJobToDraft = () => {
    openModal(ModalNamesEnum.GenericConfirmation, {
      title: 'Reset job to draft',
      description: 'This will mark the latest attempt as failed and move the job back to draft.',
      buttonText: 'Reset to draft',
      onCancel: () => closeModal(),
      onSuccess: () => {
        closeModal();
        resetMutation.mutate();
      },
    });
  };

  const isDisabled = pipelineLoading || isResettingJob;

  return (
    <MenuItemButton
      aria-label="Reset job to draft"
      aria-disabled={isDisabled}
      onClick={isDisabled ? undefined : confirmResetJobToDraft}
      className={isDisabled ? 'cursor-not-allowed opacity-60' : ''}
      title="Reset job to draft"
    >
      <Reset />
      {isResettingJob ? 'Resetting…' : 'Reset to draft'}
    </MenuItemButton>
  );
};
